import React from 'react';

import {Typography} from '@nur-portal/ui-kit';

import {getImageProps} from '../../utils/image';

import styles from './trend-preview.module.css';

const SIZES = '(max-width: 755px) calc(100vw - 40px), (max-width: 1151px) calc(100vw - 90px), 711px';

const TrendPreview = ({trend}) => {
  const imageProps = getImageProps({
    sizes: SIZES,
    async: false,
    coverImage: trend?.[0].coverImage,
    listOfWidths: [1120, 720, 560]
  });

  return (
    <div className={styles.container}>
      {!trend ? null
        : (
          <>
            <figure className={styles.figure}>
              <img
                {...imageProps}
                srcSet={imageProps.srcset.webp}
                className={styles.image}
              />
              <figcaption>
                <Typography
                  variant="text-14"
                  className={styles.caption}
                >
                  {trend?.[0].coverImage.caption}: {trend?.[0].coverImage.source}
                </Typography>
              </figcaption>
            </figure>
            <Typography variant="title-18" className={styles.description}>
              {trend?.[0].description}
            </Typography>
          </>
        )}
    </div>
  );
};

export default TrendPreview;
